/**
 * @GENERATED from Figma node 693:15902
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const GoogleContactsBright = (
  props: IconProps,
  ref: React.Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#2979FF"
      d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10"
    />
    <path
      fill="#2962FF"
      d="M12 13s-4.5 0-4.5 2.863c0 1.637.818 1.637 4.5 1.637s4.5 0 4.5-1.637C16.5 13 12 13 12 13"
    />
    <path
      fill="#fff"
      d="M12 12.5s-4.5 0-4.5 2.864C7.5 17 8.318 17 12 17s4.5 0 4.5-1.636C16.5 12.5 12 12.5 12 12.5"
    />
    <path fill="#2962FF" d="M12 11.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
    <path fill="#fff" d="M12 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
  </svg>
);
const ForwardRef = React.forwardRef(GoogleContactsBright);
export { ForwardRef as GoogleContactsBright };
